export function getServerMessage(error) {
  const data = error?.response?.data
  if (typeof data?.message === 'string' && data.message.trim()) return data.message
  if (typeof data?.error === 'string' && data.error.trim()) return data.error
  return ''
}

export function resolveErrorMessage(errorOrText, fallback) {
  if (typeof errorOrText === 'string' && errorOrText.trim()) return errorOrText
  return getServerMessage(errorOrText) || fallback
}

export function getValidationErrors(error) {
  if (error?.response?.status !== 422) return {}
  const errors = error.response.data?.errors ?? {}
  return Object.fromEntries(
    Object.entries(errors).map(([field, messages]) => [field, Array.isArray(messages) ? messages[0] : String(messages)]),
  )
}
